<template>
  <div style="background-color: #e9eaea" v-if="testemunho != null">
    <BreadCrumb class="breadCrumbPosition" :breadcrumb="breadcrumb" />
    <div class="row align-center">
      <div class="small-11 medium-10 large-9 columns">
        <Persondetail
          :testemunho="testemunho" />
        <Questionario 
          :testemunho="testemunho"
          :items="testemunhosForCurso" />
      </div>
    </div>
    <div class="row align-center" v-if="testemunhosForCurso.length > 0">
      <div class="small-12 medium-12 large-12 columns sliderwrapper">
        <WebSlider
          @slideItemClicked="testemunhoClicked"
          :items="testemunhosForCurso" />
      </div>
    </div>
    <div class="row align-center btnsDetalhe"
       :class="{'lesspadding': testemunhosForCurso.length == 0}"
         v-show="testemunho != null">
      <div class="small-11 medium-12 large-12 columns">
        <TBotao
          @click="goHome"
          style="margin-right: 15px"
          border-color="#454648"
          background-color="#454648"
          text-color="#454648">
            {{ $t('vermais') }}
        </TBotao>
        <TBotao
          style="margin-left: 15px"
          border-color="#454648"
          background-color="#454648"
          text-color="#454648"
          @click="goToCurso">
            {{ $t('pagcurso') }}
        </TBotao>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from '@/stores/store.ts';
import { computed, ref } from "vue";
import constants from "@/constants.js";
import axios from "@/axios.js";
import BreadCrumb from "@/components/BreadCrumb.vue";
import TBotao from "@/components/TBotao.vue";
import Persondetail from "@/components/personDetail.vue";
import Questionario from "@/components/questionario.vue";
import { WebSlider } from "umaui";
import { i18n } from "@/main.js";
import { useRouter } from 'vue-router';


export default {
  name: "testemunhoDetalhe",
  components: {
    BreadCrumb,
    TBotao,
    WebSlider,
    Persondetail,
    Questionario
  },
  setup(props){

    const { t } = i18n.global; 

    const store = useStore();

    const testemunho = computed(() => store.currentTestemunho);
    const testemunhosForCurso = computed(() => store.testemunhosForCurso);

    const breadcrumb = ref([
      { ID: 1, text: 'Homepage', href: "https://www.uma.pt" },
      { ID: 2, text: t("testemunhos"), route: { to: "/" } },
      { ID: 3, text: testemunho.value?.Identificacao, href: "#"}
    ]);

    const router = useRouter();

    if(testemunho.value == null){
      store.getTestemunhoByName(router.currentRoute.value.params.id).then(_ => {
        store.getTestemunhosForCurso(testemunho.value.Curso.ID)
        breadcrumb.value[2].text = testemunho.value.Identificacao;
      })
    }
    
    const perguntas = ref([ 
      t('perguntas.1'), t('perguntas.2'), 
      t('perguntas.3'), t('perguntas.4') 
    ]);
    
    return {
      breadcrumb,
      testemunhosForCurso,
      perguntas,
      testemunho,
    }
  },
  methods: {
    testemunhoClicked(testemunho){
      this.$router.push({
        name: "detalhe",
        params:{
          id: testemunho.Name,
          postid: testemunho.ID
        }
      })
    },
    goHome(){
      this.$router.push("/");
    },
    goToCurso(){
      window.location = this.testemunho.Curso.url;
    },
    getTestemunhosForCurso() {
      axios
        .get(`/testemunhos?curso=${this.testemunho.Curso.ID}`)
        .then((data) => {
          let elements = data.data.map(el => {
            return {
              ...el,
              Depoimento: this.truncate(el.Depoimento,constants.maxChars," (...)")
            }
          });
          const index = elements.findIndex((el) => el.ID == this.testemunho.ID);
          elements.push(elements.splice(index, 1)[0]);
          this.testemunhosForCurso = elements.length % 3 == 0
              ? elements
              : elements.filter(el => el.ID != this.testemunho.ID);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getTestemunhoByName(name) {
      axios
        .get(`/testemunhos/${name}`)
        .then((data) => {
          const { Questionario } = data.data;
          this.testemunho = data.data;
          this.testemunho.Questionario = Object.keys(Questionario).map(
            (k) => Questionario[k]
          );
          this.getTestemunhosForCurso();
          this.breadcrumb.push({
            ID: 3,
            text: this.testemunho.Identificacao,
            href: "#",
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    truncate(str, max, suffix){
      return str.length < max ?
          str :
          `${str.substr(0, str.substr(0, max - suffix.length).lastIndexOf(' '))}${suffix}`
    }
  }
};
</script>

<style scoped lang="scss">
@import "../global.scss";

.btnvermais{
  margin: 15px auto 0;
}

.btnsDetalhe{
  padding: 60px 0 100px;
}

.btnsDetalhe.lesspadding{
  padding-top: 0;
}

.btnsDetalhe .columns{
  display: flex;
  justify-content: center;
}

.breadCrumbPosition {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 90;
  padding-top: 15px;
}

.sliderwrapper {
  position: relative;
  padding: 0;
}

#app .row {
  max-width: 100%;
  margin-right: 0;
  margin-left: 0;
}

@media only screen and (max-width: 1439px) {
  .align-center {
    margin-left: 0px;
    margin-right: 0px;
  }
}



@media (max-width: 767px) {
  .btnsDetalhe{
    padding: 50px 0;
  }
}
</style>
